
import { Context } from "./context";
import { DefaultEventEmitter } from "./events";
import { Registry } from "./registry";


export class App extends DefaultEventEmitter
{
    constructor()
    {
        super();
    }

    context: Context;


    protected load(options?: { registry?: Registry; context?: Context; }): Context
    {
        let { registry, context } = options ?? {};

        if (context)
            return context;

        registry = registry ?? Registry.create();
        context = Context.create({ registry });

        return context;
    }
}

export interface App
{
    on(event: "update", handler: (app: App) => void): this;
}


export type Event = "update";
